import { useAuth, useSigninCheck } from 'reactfire'
import AccessDeniedComponent from './components/Admin/AccessDeniedComponent'

export function AdminOnly({ children, fallback }) {
  const auth = useAuth()
  const { data: signInCheck } = useSigninCheck({
    requiredClaims: { admin: true },
  })

  if (!signInCheck.hasRequiredClaims) {
    // Use explicit undefined check (not ??) so callers can pass
    // `fallback={null}` to suppress output entirely. Nullish coalescing
    // would treat `null` as missing and render the AccessDenied page
    // anyway — see ChangeRows.jsx where this is intentionally used
    // inside an error boundary fallback for non-admin users.
    return fallback !== undefined ? (
      fallback
    ) : (
      <AccessDeniedComponent auth={auth} />
    )
  }

  return children
}
